// extracted by mini-css-extract-plugin
export var cancelBtn = "comment-module--cancel-btn--25f57";
export var commentAuthor = "comment-module--comment-author--5fe8b";
export var commentBox = "comment-module--comment-box--ef577";
export var commentContent = "comment-module--comment-content--3f928";
export var commentTime = "comment-module--comment-time--a0baf";
export var flex = "comment-module--flex--1df6d";
export var flexContainer = "comment-module--flex-container--5ceff";
export var rating = "comment-module--rating--46272";
export var replyBtn = "comment-module--reply-btn--a7b16";